(function () {

    "use strict";

    angular
        .module("harriApp")
        .service("previewJobPostService", PreviewJobPostService);

    PreviewJobPostService.$inject = ['$q'];

    function PreviewJobPostService($q) {
        var self = this;

        self.setPreviewPayload = function (previewPayload) {
            HStorageManager.put({
                storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                key: 'previewJobPayload',
                value: previewPayload
            });
        }

        var getPreviewPayload = function () {
            return HStorageManager.get({
                storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                key: 'previewJobPayload'
            }) || {};
        }

        self.getPreviewBrandId = function () {
            var previewPayload = getPreviewPayload();
            return previewPayload.extraInfo.brandId;
        }

        self.getPreviewSelectedJobPostType = function () {
            var previewPayload = getPreviewPayload();
            return previewPayload.extraInfo.selected_job_post_type;
        }

        self.getPostType = function () {
            var previewPayload = getPreviewPayload();
            return previewPayload.extraInfo.postType;
        }

        self.getPreviewJobDetails = function () {
            var defer = $q.defer();
            var previewPayload = getPreviewPayload();
            var brandId = self.getPreviewBrandId();
            CoreReaderAPI.getPreviewJobDetails(brandId, previewPayload)
                .then(function (result) {
                    defer.resolve(result);
                })
                .catch(function (err) {
                    defer.reject(err);
                    console.error(err);
                });

            return defer.promise;
        }
    }

})();